<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="18">
        <el-card shadow="never" :body-style="{ paddingBottom: '12px' }">

          <template slot="header">
            <div class="news-title">{{ info.title }}</div>
          </template>

          <div class="news-content" v-html="info.content">
          </div>


          <div class="clearfix card-footer">
            <div class="pull-left footer-item">
              <span class="pull-left">上一篇：</span>
              <a v-if="prev" class="link ellipsis pull-left" :href="prev.id">{{ prev.title }}</a>
              <span v-if="!prev" class="link ellipsis pull-left">没有了</span>
            </div>

            <div class="pull-right footer-item text-right">
              <a v-if="next" class="link ellipsis pull-right" :href="next.id">{{ next.title }}</a>
              <span v-if="!next" class="link ellipsis pull-right" href="">没有了</span>
              <span class="pull-right">下一篇：</span>
            </div>
          </div>
        </el-card>
      </el-col>

      <el-col :span="6">
        <el-card shadow="never">
          <template slot="header">
            <span class="theme size16">相关资讯</span>
          </template>

          <list />
        </el-card>

        <el-card shadow="never" class="mt10">
          <template slot="header">
            <span class="theme size16">最新开服</span>
          </template>

          <hot-list />
        </el-card>

        <!-- <el-card shadow="never" class="mt10">
          <template slot="header">
            <span class="theme size16">热门活动</span>
          </template>

          <list />
        </el-card> -->
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data () {
    let info = null, prev = null, next = null;
    if(this.$route.query.type == 1) {
      let index = this.$datas.videoList.findIndex(c => c.id == this.$route.path)
      info = this.$datas.videoList[index]
      prev = index == 0 ? null : this.$datas.videoList[index - 1]
      next = index == this.$datas.videoList.length - 1 ? null : this.$datas.videoList[index + 1]
    } else {
      let index = this.$datas.newList.findIndex(c => c.id == this.$route.path)
      info = this.$datas.newList[index]
      prev = index == 0 ? null : this.$datas.newList[index - 1]
      next = index == this.$datas.newList.length - 1 ? null : this.$datas.newList[index + 1]
    }
    
    return {
      info: info,
      prev: prev,
      next: next,
      newList: this.$datas.newList,
      videoList: this.$datas.videoList
    }
  },

  mounted() {
    console.log(this.$route.path);
  }
}
</script>

<style lang="scss">
.news-title {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}
.news-content {
  line-height: 1.75;
  font-size: 15px;
}
.card-footer {
  margin-top: 20px;
  .footer-item {
    width: 46%;
    .link {
      display: block;
      max-width: calc(100% - 70px);
      &:hover {
        color: var(--theme);
      }
    }
  }
}  
</style>
